export interface BcmBerthCategoryDto {
    id?: number;
    name: string;
    description?: string | null;
}

export class BcmBerthCategory {
    // matches bcm_berth_categories.name varchar(100) in the API
    static readonly NAME_MAX_LENGTH = 100;
    // matches bcm_berth_categories.description varchar(255) in the API
    static readonly DESCRIPTION_MAX_LENGTH = 255;

    id: number;
    name: string;
    description: string | null;

    constructor(dto: BcmBerthCategoryDto) {
        this.id = dto.id;
        this.name = dto.name;
        this.description = dto.description ?? null;
    }
}
